<template>
  <!-- Skeleton loading cards — match visual density during load -->
  <div class="skeleton-grid" v-if="visible">
    <div
      v-for="i in count"
      :key="i"
      class="skeleton-card"
    >
      <div class="skeleton-line w-60"></div>
      <div class="skeleton-line w-80"></div>
      <div class="skeleton-line w-40"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    visible: { type: Boolean, default: true },
    count:   { type: Number, default: 4 },
  }
}
</script>

<style scoped>
.skeleton-grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: rgba(255,255,255,0.02);
  border-radius: var(--radius-lg);
  overflow: hidden;
  padding: 0 var(--s-4);
}
.skeleton-card {
  padding: var(--s-4);
  border-bottom: 1px solid rgba(255,255,255,0.04);
}
.skeleton-card:last-child { border-bottom: none; }
.skeleton-line {
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  margin-bottom: 8px;
}
.skeleton-line:last-child { margin-bottom: 0; }
.w-60 { width: 60%; }
.w-80 { width: 80%; }
.w-40 { width: 40%; }
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
